var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSafetyAndProtection = function SvgSafetyAndProtection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#safety-and-protection_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#13CFE8",
    d: "M2.281 3.969 8 1.544l5.719 2.425a.44.44 0 0 1 .281.4c-.012 2.856-1.2 7.79-5.822 10.003a.41.41 0 0 1-.353 0C3.2 12.156 2.015 7.225 2 4.366c0-.157.097-.32.281-.4zm12.022-1.381L8.42.09a1 1 0 0 0-.838 0L1.697 2.587A1.94 1.94 0 0 0 .5 4.376c.016 3.1 1.29 8.772 6.675 11.35.522.25 1.128.25 1.65 0 5.388-2.578 6.66-8.25 6.675-11.35a1.94 1.94 0 0 0-1.197-1.787M9.75 6.5a1.751 1.751 0 0 0-3.5 0c0 .697.41 1.3 1 1.581v2.169c0 .416.334.75.75.75s.75-.334.75-.75V8.081c.59-.281 1-.884 1-1.581"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "safety-and-protection_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSafetyAndProtection;